import * as React from 'react';
import _ from 'lodash';

interface State {
  numberOfDots: number;
  interval?: string;
}

const MAX_DOTS = 3;
const MIN_DOTS = 0;

export default class LoadingDots extends React.Component<{}, State> {
  state = {
    numberOfDots: MIN_DOTS,
  }

  componentDidMount() {
    const interval = setInterval(this.increment, 500);
    this.setState({ interval });
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  increment = () => {
    let { numberOfDots } = this.state;

    if (numberOfDots === MAX_DOTS) {
      numberOfDots = MIN_DOTS;
    } else {
      numberOfDots += 1;
    }

    this.setState({ numberOfDots });
  }

  render() {
    const { numberOfDots } = this.state;
    const dots = _.range(numberOfDots).map(() => '.').join('');

    return (
      <span>{dots}</span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/LoadingDots.js